// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"100px","mobileHeaderHeight":"138px","filtersContainerHeight":"75px","mobileFiltersContainerHeight":"52px"};